"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.accountGrade.list': 'Price Packages',
    'route.accountGrade.create': 'Create Price Package',
    'route.accountGrade.edit': 'Edit Price Package',
    'route.accountGrade.preview': 'Price Package Preview',
};
